module.exports = __webpack_public_path__ + "img/food_10.83385d11.jpg";